(function() {
  const initWellnessBundle = () => {
    const sections = document.querySelectorAll('[class^="wellness-bundle-"]');
    
    sections.forEach(section => {
      if (!section || section.classList.contains('js-initialized')) return;

      const heroWrapper = section.querySelector('.hero-image-wrapper');
      if (heroWrapper) {
        heroWrapper.addEventListener('mouseover', (e) => {
          const spot = e.target.closest('.hotspot');
          if (!spot) return;
          const idx = spot.getAttribute('data-index');
          const target = section.querySelector(`#card-${idx}`);
          if (target) target.classList.add('highlight');
        });

        heroWrapper.addEventListener('mouseout', (e) => {
          const spot = e.target.closest('.hotspot');
          if (!spot) return;
          const idx = spot.getAttribute('data-index');
          const target = section.querySelector(`#card-${idx}`);
          if (target) target.classList.remove('highlight');
        });

        heroWrapper.addEventListener('click', (e) => {
          const spot = e.target.closest('.hotspot');
          if (!spot) return;
          const idx = spot.getAttribute('data-index');
          const targetCard = section.querySelector(`#card-${idx}`);
          if (!targetCard) return;

          if (window.innerWidth <= 749) {
            const productLink = targetCard.querySelector('a');
            if (productLink) window.location.href = productLink.href;
          } else {
            targetCard.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
            targetCard.classList.add('highlight');
            setTimeout(() => targetCard.classList.remove('highlight'), 800);
          }
        });
      }

      const addBtn = section.querySelector('[data-action="add-bundle"]');
      if (addBtn) {
        addBtn.addEventListener('click', async () => {
          const items = [];
          section.querySelectorAll('.bundle-product-id').forEach(input => {
            if (input.value) items.push({ id: parseInt(input.value, 10), quantity: 1 });
          });

          if (items.length === 0) return;

          const originalText = addBtn.innerText;
          addBtn.innerText = 'Adding...';
          addBtn.disabled = true;

          try {
            const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ items: items })
            });
            if (response.ok) {
              window.location.href = '/cart';
            } else {
              throw new Error('Cart sync issue');
            }
          } catch (e) {
            addBtn.innerText = originalText;
            addBtn.disabled = false;
            console.error(e);
          }
        });
      }

      section.classList.add('js-initialized');
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initWellnessBundle);
  } else {
    initWellnessBundle();
  }
})();